import { PaymentMethodOption } from "@redotech/redo-model/return-flow/condition";
import { ConditionTypeDetailsProps } from "@redotech/redo-return-ui/flows/return-flow/condition";
import { PaymentMethodState } from "@redotech/redo-return-ui/flows/return-flow/condition-types/payment-method";
import { RedoListItem } from "@redotech/redo-web/arbiter-components/list/redo-list";
import { RedoSingleSelectDropdownInput } from "@redotech/redo-web/arbiter-components/select-dropdown/redo-single-select-dropdown-input";
import { memo, useMemo } from "react";

export const PaymentMethodDetails = memo(function PaymentMethodDetails({
  state,
  setState,
  disabled,
}: ConditionTypeDetailsProps<PaymentMethodState>) {
  const paymentMethodOptions: RedoListItem<PaymentMethodOption>[] = useMemo(
    () =>
      Object.values(PaymentMethodOption).map((method) => ({
        id: method,
        value: method,
        type: "text" as const,
        text: method,
      })),
    [],
  );

  const selectedMethod = state
    ? paymentMethodOptions.find((option) => option.value === state)
    : undefined;

  return (
    <RedoSingleSelectDropdownInput
      disabled={disabled}
      flexGrow
      label="Original payment method"
      options={paymentMethodOptions}
      optionSelected={({ item }) => setState(item.value ?? null)}
      placeholder="Select payment method..."
      selectedItem={selectedMethod}
      size="xs"
    />
  );
});
